import template from './config.html.twig';
import './config.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
